import { WORK_INSTRUCTION_HISTORY_TYPES } from '@eapproval/offer-shared'

const toTime = (value) => {
  const time = new Date(value ?? 0).getTime()
  return Number.isNaN(time) ? 0 : time
}

/**
 * A PR submission's `history` is a generic log. The
 * "Work Instruction – History & Documents" modal shows only the work
 * instruction entries, newest first.
 */
export const getWorkInstructionHistory = (history) => {
  if (!Array.isArray(history)) {
    return []
  }

  return history
    .filter((entry) => WORK_INSTRUCTION_HISTORY_TYPES.includes(entry?.type))
    .sort((a, b) => toTime(b?.date) - toTime(a?.date))
}
